<template>
  <LayoutDefault>
    <div class="container dark" id="dashboard">
      <template v-if="$auth.ready() && $auth.check()">
        <div class="blocks">
          <section class="block personal-data">
            <div class="col text-data">
              <ChangeProfilePic />

              <!-- WEBSTAR BUTTON -->
              <div class="monetize-container" v-if="!$auth.user().is_webstar">
                <a
                  class="menu-link active"
                  :href="WEBSTARPANEL_URL"
                >
                  {{ $t("dashboard.monetize.button") }}
                </a>
                <span>{{ $t("dashboard.monetize.description") }}</span>
              </div>
              <div class="monetize-container" v-else>
                <a
                  class="menu-link active"
                  :href="WEBSTARPANEL_HOME_URL"
                >
                  {{ $t("header.my_panel") }}
                </a>
              </div>

              <!-- USERNAME -->
              <p>
                <span class="field">{{ $t("placeholder.username") }}:</span>
                {{ $auth.user().username }}
              </p>
              <router-link
                v-if="!$auth.user().username_updated"
                class="menu-link"
                :to="{ name: 'change_username' }"
              >
                {{ $t("dashboard.change_username.title") }}
              </router-link>

              <!-- PASSWORD -->
              <router-link class="menu-link" :to="{ name: 'change_password' }">
                {{ $t("dashboard.change_password.title") }}
              </router-link>
              
              <!-- NOTIFICATIONS -->
              <router-link v-if="notificationsEnabled" class="menu-link" :to="{ name: 'notifications' }">
                {{ $t("dashboard.notifications_settings.title") }}
              </router-link>

              <p>
                <span class="field">{{ $t("dashboard.member_since") }}:</span>
                {{ $d(new Date($auth.user().created_at), "short") }}
              </p>
              <p>
                <span class="field">{{ $t("placeholder.email") }}:</span>
                {{ $auth.user().email }}
              </p>

            </div>
          </section>
          <section class="block personal-data">
            <div class="col">
              <h2>{{ $t("dashboard.my_shopping") }}</h2>

              <div class="group">
                <router-link class="menu-link" :to="{ name: 'category.index' }">
                  DIVASTV
                </router-link>
              </div>

              <div class="group">
                <router-link
                  class="menu-link"
                  :to="{ name: 'purchase.tokens' }"
                >
                  {{ $t("dashboard.tokens.buy") }}
                </router-link>
                <router-link class="menu-link" :to="{ name: 'tokens' }">
                  {{ $t("dashboard.tokens.title") }}
                </router-link>
              </div>

              <div class="group">
                <router-link class="menu-link" :to="{ name: 'payments' }">
                  {{ $t("dashboard.payments.title") }}
                </router-link>
                <router-link class="menu-link" :to="{ name: 'subscriptions' }">
                  {{ $t("dashboard.subscriptions.title_active") }}
                </router-link>
              </div>

              <div class="group">
                <router-link class="menu-link active" :to="{ name: 'claims' }">
                  {{ $t("dashboard.claims") }}
                </router-link>
              </div>
            </div>
          </section>
        </div>

        <router-link class="cancel active" :to="{ name: 'home' }">
          <span class="text-center">{{ $t("tokens_modal.button_back") }}</span>
        </router-link>
      </template>
    </div>
  </LayoutDefault>
</template>

<script>
// import VideoBox from "../components/VideoBox";
import Spinner from "../components/Spinner";
import ResourceTable from "../components/ResourceTable";
import resources from "../resources";
import EventBus from "../eventbus";
// import ResourceScroller from "../components/ResourceScroller";
// import ResourceScrollerMovieBox from "../components/ResourceScroller.MovieBox";
import LayoutDefault from "../layouts/LayoutDefault";
import FullBackdrop from "../components/FullBackdrop";
import ChangeProfilePic from "../components/CallToAction/ChangeProfilePic";

export default {
  mounted() {
    this.checkDesktop();
    window.addEventListener("resize", this.checkDesktop);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkDesktop);
  },
  components: {
    LayoutDefault,
    // ResourceScroller,
    // VideoBox,
    Spinner,
    ResourceTable,
    // ResourceScrollerMovieBox,
    FullBackdrop,
    ChangeProfilePic,
  },
  data() {
    return {
      user: null,
      isDesktop: false,
      WEBSTARPANEL_URL: resources.webstars.RegisterUrl(),
      WEBSTARPANEL_HOME_URL: resources.webstars.HomeUrl(),
    };
  },
  computed: {
    favoritedMoviesScroller() {
      return {
        resource: resources.movies,
        defaultParams: {
          include: [],
          favorited: true,
        },
      };
    },
    likedMoviesScroller() {
      return {
        resource: resources.movies,
        defaultParams: {
          include: [],
          liked: true,
        },
      };
    },
    notificationsEnabled() {
      return !!(process.env.VUE_APP_NOTIFICATIONS_ENABLED && process.env.VUE_APP_NOTIFICATIONS_ENABLED === 'true');
    }
  },
  methods: {
    checkDesktop() {
      this.isDesktop = window.innerWidth >= 768;
    },
  },
};
</script>

<style scoped lang="scss">
@import "../styles/variables";
@import "../styles/classes";

#dashboard {
  box-sizing: border-box;
  min-height: 500px;
  padding: 9px;

  display: flex;
  flex-direction: column;

  .banners {
    .banner {
      height: 400px;
      background-size: cover;
      background-position: center;
    }
  }

  .favorited-movies {
    min-height: 200px;

    .movie {
      width: 200px;

      &.horizontal {
        width: 500px;
      }
    }
  }

  .liked-movies {
    min-height: 200px;

    .movie {
      width: 200px;

      &.horizontal {
        width: 500px;
      }
    }
  }

  .blocks {
    //display: block;
    display: flex;
    flex-direction: row;
    //margin-bottom: 100px;
    height: 100%;
    min-height: 500px;

    @media (max-width: 768px) {
      flex-direction: column;
    }

    .block.personal-data {
      display: flex;
      text-align: center;
      flex-basis: 50%;
      padding: 1em 3em;

      @media (max-width: 768px) {
        padding: 0em 3em;
        margin-bottom: 0px;
      }

      > .col {
        flex: 1;
        padding: 1em;
      }

      .text-data {
        text-align: start;
        padding-bottom: 0 !important;

        .field {
          font-weight: bold;
          padding-right: 0.25em;
        }
      }

      .menu-link {
        @extend %fresh-btn;
        display: block;
        padding: 0.5rem;
        margin-top: 1em;
        text-align: center;
      }

      .menu-link:not(:last-child) {
        margin-bottom: 0;
      }
    }
  }

  .cancel {
    @extend %fresh-btn;
    border-radius: 0.5rem;
    width: 115px;
    align-self: center;

    // margin-top: 32px;
    margin-bottom: 38px;
  }
}

.support-link {
  display: block;
  width: fit-content;
  margin: 50px auto;
}

.group {
  width: 100%;
  margin-bottom: 2em;

  &:last-child {
    margin-bottom: 0;
  }
}

.monetize-container {
  display: flex;
  flex-direction: column;

  span {
    width: 100%;
    margin-top: 0.5em;
    margin-inline: auto;

    text-align: center;
    font-weight: bold;
    font-size: 0.8em;
  }
}
</style>
